import { mPerLat, mPerLon } from './geo';
import { useEffect, useState } from 'react';
import { rotatePts, offsetM } from './excavation';

// shared state of the free move/rotate editor for areas (one at a time)
let st = null;
const subs = new Set();
const emit = () => { window.__gissAreaEdit = !!st; subs.forEach((f) => f(st)); };
export const getAe = () => st;
export const setAe = (p) => { st = st ? { ...st, ...p } : null; emit(); };
export function useAe() {
  const [v, setV] = useState(st);
  useEffect(() => { subs.add(setV); return () => subs.delete(setV); }, []);
  return v;
}
// opts: { pts, onSave(pts, rot), hide, label, extra: { label, onClick }, duplicate(pts) -> opts of the copy }
export const editArea = (opts) => { st = { ...opts, orig: opts.pts, rot: 0 }; emit(); };
export const closeArea = (save) => { const s = st; st = null; emit(); if (save && s) s.onSave(s.pts, s.rot); };

export const centroid = (pts) => [pts.reduce((s, p) => s + p[0], 0) / pts.length, pts.reduce((s, p) => s + p[1], 0) / pts.length];
// clockwise bearing (deg) of q seen from c
export const bearing = (c, q) => { const [x, y] = offsetM(c, q); return (Math.atan2(x, y) * 180) / Math.PI; };
export const norm = (d) => ((Math.round(d) % 360) + 360) % 360;
// rotate clockwise by deg around the centroid
export const turn = (pts, deg, c = centroid(pts)) => rotatePts(pts, c, -deg);
export const shift = (pts, from, to) => pts.map(([a, b]) => [a + to[0] - from[0], b + to[1] - from[1]]);
// rotation handle: north of the centroid, beyond the farthest vertex
export const rotHandle = (pts, deg) => {
  const c = centroid(pts), r = Math.max(4, ...pts.map((p) => Math.hypot(...offsetM(c, p)))) * 1.35, a = (deg * Math.PI) / 180;
  return [c[0] + (r * Math.cos(a)) / mPerLat(c[0]), c[1] + (r * Math.sin(a)) / (mPerLon(c[0]))];
};
// mirror around the centroid: 'lr' = left/right, 'ud' = up/down
export const mirror = (pts, axis) => { const c = centroid(pts); return pts.map(([a, b]) => (axis === 'lr' ? [a, 2 * c[1] - b] : [2 * c[0] - a, b])); };
// copy placed right next to the original (east, 2 m gap)
export const besideRight = (pts) => {
  const lo = pts.map((p) => p[1]), gap = 2 / (mPerLon(pts[0][0]));
  const d = Math.max(...lo) - Math.min(...lo) + gap;
  return pts.map(([a, b]) => [a, b + d]);
};
export const copyName = (n, t) => `${n || ''} (${t.aeCopy})`.trim();
